// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"388":"result","446":"questionnaire"}[chunkId] + "." + {"388":"a32873ba","446":"83cb8cad"}[chunkId] + ".css";
};